'use strict';
import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_DATOS_EJECUCION,
    CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_MENSAJE_ERROR,
    CONTABILIZADORRECONTABILIZADOR_CAMBIAR_VALOR_COMBO,
    CONTABILIZADORRECONTABILIZADOR_CARGA_BARRA_AVANCE,
    CONTABILIZADORRECONTABILIZADOR_CARGA_DATOS_COMBO,
    CONTABILIZADORRECONTABILIZADOR_CARGAR_PERMISOS_USUARIO,
    CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER,
    CONTABILIZADORRECONTABILIZADOR_CAMBIAR_CHECK,
    CONTABILIZADORRECONTABILIZADOR_DESPLEGAR_PROCESOS,
    CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL_MENSAJE_RESULTADO,
    CONTABILIZADORRECONTABILIZADOR_FILTRAR_MODELOS,
    CONTABILIZADORRECONTABILIZADOR_POBLAR_GRILLA_RECONTABILIZADOR,
    CONTABILIZADORRECONTABILIZADOR_GUARDAR_QUITAR_MODELO_SELECCIONADO,
    CONTABILIZADORRECONTABILIZADOR_INHABILITAR_FECHA_ORIGINAL,
    CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL,
    CONTABILIZADORRECONTABILIZADOR_OCULTAR_BOTON_VERMAS,
    CONTABILIZADORRECONTABILIZADOR_SELECCIONAR_RB,
    CONTABILIZADORRECONTABILIZADOR_PROCESOS_EN_EJECUCION,
    CONTABILIZADORRECONTABILIZADOR_SETEAR_EJECUCION_LOTE,
    INITIAL_STATE
} from '../../Screens/ContabilizadorRecontabilizador/actions/Actions';

const initialState = {
    modalProceso: false,                                                            //Flag que determina la visualización del pop-up del modal de logs de procesos. false - no se muestra modal / true - se muestra modal
    esEjecucionGeneral: false,                                                      //Flag que determina que determina si clickeas el boton "Ejecutar" o  "Ejecucion Individual"
    modalConfirmacionEjecucion: false,                                              //Flag que determina la visualización del pop-up del modal de confirmacion de ejecucion. false - no se muestra modal / true - se muestra modal
    modalInformarProximoPaso: false,                                                //Flag que determina la visualización del pop-up del modal que informa el próximo paso de ejecución del contabilizador/recontabilizador. false - no se muestra modal / true - se muestra modal
    modalSeleccionModelos: false,                                                   //Flag que determina la visualización del pop-up del modal de "Modelos Contables". false - no se muestra modal / true - se muestra modal
    idRegistro: undefined,                                                          //Variable que guarda el Id del registro a mostrar en el pop-up de logs de procesos.
    confirmaEjecucion: false,                                                       //Flag que determina la ejecucion de un proceso. false - no se ejecuta / true - se ejecuta
    nombreProceso : "",                                                             //Variable que contiene el nombre del proceso que se está ejecutando para mostrar en el mensaje de error
    tipoEjecucion : 0,                                                              //Variable que contiene el id del tipo de ejecucion (0 Lote // 1 Ejecucion de Contabilidad del dia)             
    muestraMensajeErrorEjecucion : false,                                           //Flag que determina si se va a mostrar un error en el ModalConfirmaEjecucion, en caso de estar en true se muestra al usuario un menasje informando el fallo en la ejecucion                  
    estaDesplegado: false,                                                          //Flag que determina si se muestra la sección desplegable con los pasos del Contabilizador/Recontabilizador. false - no está desplegado / true - está desplegado
    modelosContablesActivos: [],                                                    //Array que contiene los modelos contables activos recibidos por obtención de datos.
    datosCombo: [],                                                                 //Array que contiene los datos obtenidos del SP para el combo de procesos                                         
    mostrarVerMas: true,                                                            //Flag que determina si se verá el botón "Ver más" en la sección de modelos seleccionados. false - no se muestra el botón / true - se muestra
    mostrarSpinner: false,                                                          //Flag utilizado para mostrar u ocultar el spinner de carga.
    barraAvance : [],                                                               //Array que contiene los datos de la barra de avance del proceso de Contabilización/Recontabilización.
    esPrimerPaso: true,                                                             //Flag utilizado para inhabilitar la fecha original.
    hayProcesosEnEjecucion: false,                                                  //Flag utilizado para saber si hay procesos en ejecucion en ese momento.
    ejecucionLoteIniciada: false,                                                   //Flag utilizado para saber si hay una ejecucón por lote en ese momento.
    permisosUsuario: [],                                                            //Array con los permisos sobre el Feature de CONTABILIDAD que tiene el usuario logeado.    
    registroEjecucionCabecera : [],                                                 //Array que contiene los registros de ejecucion en la cabecera del modalProceso Contabilización/Recontabilización.
    registroEjecucionDetalle : [],                                                  //Array que contiene los registros de ejecucion del detalle del modalProceso de Contabilización/Recontabilización.
    habilitarEjecucionReconta: true,                                                //Flag utilizado para determinar si los componentes del Re-contabilizador deben estar habilitados o no. Esto se evalúa dependiendo si la fecha escogida como "Fecha Contabilidad Original" se corresponde con alguna ejecución realizada.
    ultimaFechaContabilizacion: new Date().toLocaleDateString('en-GB'),             //Fecha de la última contabilización hecha. Este dato se obtiene de la OD "AD17P_GET_BARRA_AVANCE" y se guarda al momento de entrar a la pantalla dónde está la opción de "Contabilización" seleccionada por defecto
    inputsContabilizadorRecontabilizador: {                                         //Objeto que contiene los datos asociados a inputs de la pantalla y modales.
        inputFechaContabilidadOriginal: new Date().toLocaleDateString('en-GB'),         //Variable que guarda el valor de input para la fecha de contabilidad original.
        modalSeleccionModelos: {                                                        //Objeto que contiene los datos referidos al modal de selección de modelos contables
            inputBuscadorModelos: "",                                                       //Variable que guarda los valores ingresados por el usuario a través del buscador de modelos contables
            modelosContablesFiltrados: [],                                                  //Array que guarda los modelos a mostrar como opciones del buscador filtrados por el input del buscador de modelos contables
            modelosContablesSeleccionados: [],                                              //Array que guarda los modelos seleccionados por el usuario
        },
        errorValidacion: {                                                              //Objeto contenedor creado para guardar la información de errores de validación de componentes que deban validarse.
            inputIndicadorFecha: ""                                                         //Flag que indica si el componente "inputIndicadorFecha" tuvo error de validación.       
        }   
    },
    radioButtonsContabilizador: {                                                   //Objeto que aloja los valores de los radiobuttons de la pantalla de Contabilizador/Recontabilizador
        contabilizacion: 0                                                              //0 - "Contabilizador" / 1 - "Re-contabilizador"
    },
    combosContabilizador: {                                                         //Objeto que aloja los valores del combo de procesos
        comboProceso: -1                                                              //-1 valor por defecto
    },
    checksContabilizador: {
        modalSeleccionModelos: {
            checkTodosModelos: true
        }
    }
}

function contabilizadorRecontabilizador(state = initialState, action) {
    LogHelper.In(contabilizadorRecontabilizador.name, state, action);
    let result;

    switch (action.type) {
        case INITIAL_STATE: {
            state = initialState;


            result = {
                ...state
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_POBLAR_GRILLA_RECONTABILIZADOR: {
            let inputs = JSON.parse(JSON.stringify(state.inputsContabilizadorRecontabilizador));
            let checks = JSON.parse(JSON.stringify(state.checksContabilizador));

            inputs.errorValidacion.inputIndicadorFecha = action.errorValidacion ? action.errorValidacion : "";
            inputs.modalSeleccionModelos.modelosContablesFiltrados = action.modelosContables;
            inputs.modalSeleccionModelos.modelosContablesSeleccionados = action.modelosSeleccionados;

            checks.modalSeleccionModelos.checkTodosModelos = action.checkTodosModelos;

            result = {
                ...state,
                inputsContabilizadorRecontabilizador: inputs,
                checksContabilizador: checks,
                modelosContablesActivos: action.modelosContablesActivos,
                habilitarEjecucionReconta: action.habilitarEjecucionReconta
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_DATOS_EJECUCION: {
            result = {
                ...state,
                registroEjecucionCabecera : action.registroEjecucionCabecera,
                registroEjecucionDetalle : action.registroEjecucionDetalle,
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL: {
            result = {
                ...state,
                [action.nombreModal]: action.mostrarModal,
                idRegistro: action.idRegistro,
                confirmaEjecucion: action.confirmaEjecucion,
                nombreProceso: action.nombreProceso,
                esEjecucionGeneral: action.esEjecucionGeneral,
                tipoEjecucion: action.tipoEjecucion,
                muestraMensajeErrorEjecucion: action.muestraMensajeErrorEjecucion
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_SELECCIONAR_RB: {
            result = {
                ...state,
                radioButtonsContabilizador: {
                    [action.nombreRB]: action.valorRB,
                    habilitarEjecucion: true
                }
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_CARGAR_PERMISOS_USUARIO: {
            result = {
                ...state,
                permisosUsuario: action.permisos
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_MOSTRAR_SPINNER: {
         result = {
                ...state,
                mostrarSpinner: action.valor
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_MOSTRAR_MODAL_MENSAJE_RESULTADO: {

            result = {
                ...state,
                modalMensajeResultado: action.mensaje,
                redireccionarPantallaPrincipal: action.redireccionarPantallaPrincipal
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_PROCESOS_EN_EJECUCION: {
            result = {
                   ...state,
                   hayProcesosEnEjecucion: action.valor
               }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_SETEAR_EJECUCION_LOTE: {
            result = {
                   ...state,
                   ejecucionLoteIniciada: action.valor
               }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_DESPLEGAR_PROCESOS: {
            result = {
                ...state,
                estaDesplegado: action.estaDesplegado
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_GUARDAR_QUITAR_MODELO_SELECCIONADO: {
            result = {
                ...state,
                inputsContabilizadorRecontabilizador: action.inputs,
                checksContabilizador: action.checks,
                mostrarVerMas: action.mostrarVerMas
            };
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_INHABILITAR_FECHA_ORIGINAL: {
            result = {
                ...state,
                esPrimerPaso : action.esPrimerPaso
            }
        }
        break;


        case CONTABILIZADORRECONTABILIZADOR_FILTRAR_MODELOS: {
            result = {
                ...state,
                inputsContabilizadorRecontabilizador: action.inputs
            };
        }
        break;


        case CONTABILIZADORRECONTABILIZADOR_OCULTAR_BOTON_VERMAS: {
            result = {
                ...state,
                mostrarVerMas: false
            };
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_CAMBIAR_CHECK: {
            let inputs = JSON.parse(JSON.stringify(state.inputsContabilizadorRecontabilizador));
            let checks = JSON.parse(JSON.stringify(state.checksContabilizador));
            inputs = action.inputs;
            checks = action.checks;
            
            result = {
                ...state,
                checksContabilizador: checks,
                inputsContabilizadorRecontabilizador: inputs
            };
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_ACTUALIZAR_MENSAJE_ERROR: {
            let inputs = JSON.parse(JSON.stringify(state.inputsContabilizadorRecontabilizador));
            
            inputs.errorValidacion.inputIndicadorFecha = action.errorValidacion;


            result = {                
                ...state,
                inputsContabilizadorRecontabilizador: inputs
            };
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_CARGA_BARRA_AVANCE: {
            let inputs = JSON.parse(JSON.stringify(state.inputsContabilizadorRecontabilizador));
            let ultimaFechaContabilizacion = JSON.parse(JSON.stringify(state.ultimaFechaContabilizacion));
            let fecha = action.esContabilizacion ? action.barraAvance[0].FechaEjecucion 
                                                 : action.fechaInput ? action.fechaInput
                                                                     : action.barraAvance[0].FechaContabilidadOriginal;

            //Si se trata de una contabilización (se cambió la opción por RB), actualizo "ultimaFechaContabilizacion" con dicha fecha
            if(action.esContabilizacion) {
                ultimaFechaContabilizacion = action.barraAvance[0].FechaEjecucion;
            }

            //Si "action.mostrarUltimaFechaConta" es true, quiere decir que se cambió el RB hacia "Re-Contabilización", por lo tanto muestro "ultimaFechaContabilizacion", sino actualizo con la fecha que corresponda
            inputs.inputFechaContabilidadOriginal = action.mostrarUltimaFechaConta ? ultimaFechaContabilizacion : new Date(fecha).toLocaleDateString('en-GB');

            result = {
                ...state,
                barraAvance: action.barraAvance,
                inputsContabilizadorRecontabilizador: inputs,
                ultimaFechaContabilizacion
            }
        }
        break;

        case CONTABILIZADORRECONTABILIZADOR_CARGA_DATOS_COMBO: {
            result = {
                    ...state,
                    datosCombo : action.datosCombo
                }
            }
        break;
           
        case CONTABILIZADORRECONTABILIZADOR_CAMBIAR_VALOR_COMBO: {
            let combos = JSON.parse(JSON.stringify(state.combosContabilizador));

            combos[action.nombreCombo] = action.valorCombo;

            result = {
                ...state,
                combosContabilizador : combos
            }
        }
        break;
        
        default:
            result = {
                ...state
            };
        break;

    }

    LogHelper.Out(contabilizadorRecontabilizador.name, result);

    return result;
}


export default contabilizadorRecontabilizador;